export default (keys, prefix = '') => {
  const index = {}

  keys.forEach(key => {
    index[key] = `${prefix}${key}`
  })

  return index
}
